import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(20, 4.5, 6),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(10, 3, 6),
      flexDirection: 'column-reverse',
      gap: theme.spacing(2),
    },
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },

  divider: {
    height: 16,
    width: 1,
    backgroundColor: theme.palette.grey[200],

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  logoLink: {
    width: 120,
  },

  logo: {
    width: '100%',
    height: 'auto',
  },

  link: {
    color: theme.palette.grey[200],
    fontWeight: 400,
    textTransform: 'uppercase',

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },

  docs: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(5),
  },

  centeredLink: {
    position: 'absolute',
    textAlign: 'center',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: theme.spacing(6.8),

    [theme.breakpoints.down('lg')]: {
      left: '60%',
    },

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  socials: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(5),
  },
}));
